import { BU_ACTION_TYPES } from './business-units-types';

const INITIAL_STATE = {
    isLoading: false,
    businessUnits: [],
    error: null,
};

export const buReducer = (state = INITIAL_STATE, action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case BU_ACTION_TYPES.FETCH_BUSINESS_UNITS_START:
            return { ...state, isLoading: true };
        case BU_ACTION_TYPES.FETCH_BUSINESS_UNITS_SUCCESS:
            return { ...state, isLoading: false, businessUnits: payload };
        case BU_ACTION_TYPES.FETCH_BUSINESS_UNITS_FAILED:
            return { ...state, isLoading: false, error: payload };
        default:
            return state;
    }
};

